module.exports = __webpack_public_path__ + "static/faculdade-souza-4fc111c85eb3ef5a16f1676e3db506ee.png";